import React from "react";

const Card = (props) => {

  const Heading = props.title ? (() => {
    const validHeadingLevels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    const safeHeading = props.headingLevel ? props.headingLevel.toLowerCase() : '';
    return validHeadingLevels.includes(safeHeading) ? safeHeading : 'div';
  })() : null;

  return (
    <div className={`msync-card ${props.className ? props.className : ''}`}>
      {props.title && (
        <div className="msync-card__header">
          {Heading && <Heading className="msync-card__header__title msync-title">{ props.title }</Heading>}
        </div>
      )}
      { props.children }
    </div>
  );
}

export default Card;
